export enum Role {
    ACCOUNT_MANAGER = "ACCOUNT_MANAGER",
    RECRUITER = "RECRUITER",
    NON_PRODUCER = "NON_PRODUCER",
    NA = "N/A",
  }
  
  export type User = {
    azure: {
      id: string;
      department?: string;
      email?: string;
      first_name?: string;
      full_name?: string;
      last_name?: string;
    };
    bullhorn: {
      id: string;
      is_enabled?: boolean;
      first_name?: string;
      last_name?: string;
      full_name?: string;
      occupation?: string;
      primary_department?: {
        id: string;
      };
      type?: {
        id: string;
        name?: string;
      };
    };
    boss_created_at?: string;
    boss_updated_at?: string;
    role?: {
      name: Role;
      active_role: Role;
    };
  };